import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextEditorComponent } from './text-editor.component';
import { SanitizeHtmlPipe } from './config/sanitize-html.pipe';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import { TextEditorService } from './config/text-editor.service';
import {EmojiModule} from '../emoji/emoji.module';



@NgModule({
  declarations: [TextEditorComponent,SanitizeHtmlPipe],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatButtonModule,
    MatToolbarModule,
    EmojiModule
  ],
  exports: [
    TextEditorComponent
  ],
  providers: [
    TextEditorService
  ]
})
export class TextEditorModule { }
